import PropTypes from "prop-types";
import React from "react";
import { useLocation } from "react-router-dom";
import Hub from "../components/Hub";
import HubList from "../components/HubList";

const measureCharts = [
  {
    type: "pulseox",
    label: "Pulseox",
    value: [
      {
        key: "spo2",
        color: "#8884d8",
        bounds: [81],
      },
      {
        key: "bpm",
        color: "#82ca9d",
        bounds: [45, 120],
      },
    ],
  },
  {
    type: "temperature",
    label: "Temperature",
    value: [{ key: "celsius", color: "#BE4297", bounds: [96, 101.5] }],
  },
];

export default function PressureCheck({ programId }) {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const hubId = queryParams.get("hub");
  return !hubId ? (
    <HubList programId={programId} measureCharts={measureCharts} />
  ) : (
    <Hub hubId={hubId} programId={programId} measureCharts={measureCharts} />
  );
}
PressureCheck.propTypes = {
  programId: PropTypes.string.isRequired,
};
